import React, { useState } from "react";
import { Alert, Button } from "reactstrap";
import { errorHandler, openUrlOnNewTab } from "../helper-methods";
import { reDoUserKycLink } from "../http-calls";
import { useSelector } from "react-redux";

const ReKYCCard = () => {
  const userData = useSelector((state) => state?.userData);

  const [loading, setLoading] = useState(false);

  const _getAndRedirectUserReKycLink = async () => {
    try {
      setLoading(true);

      const res = await reDoUserKycLink();

      if (res?.kycLink?.url) {
        openUrlOnNewTab(res.kycLink.url);
      } else {
        throw new Error();
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  if (
    !userData?.user?.stripeKycRequire ||
    userData?.user?.isScheduleForAccountDelete
  ) {
    return <></>;
  }

  return (
    <>
      <Alert color="danger">
        <i className="fa fa-exclamation-triangle alertIconDanger" />
        <p>
          Dear Creator, To ensure uninterrupted payments, please update the KYC
          information for account(Ignore if already done). Thank you for your
          cooperation.
        </p>
        <hr style={{ margin: "0.9rem 0" }} />
        <Button
          className="themeBtn addBtn"
          disabled={loading}
          onClick={() => _getAndRedirectUserReKycLink()}
        >
          {loading ? <i className="fa fa-spinner fa-spin mr-2" /> : null}
          Proceed
        </Button>
      </Alert>
    </>
  );
};

export default ReKYCCard;
